import { Breadcrumb, Card, Empty, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Panel } from 'src/components/Panel';
import { Speech } from 'src/types/speech';

const COURSE_LIST_QUERY = gql`
  query courseList($ids: [ID], $lessonIds: [ID]) {
    courses(ids: $ids) {
      id
      name
      description
      createdAt
      lessons(lessonIds: $lessonIds) {
        id
        name
        speeches {
          id
          content
          type
          group
        }
      }
    }
  }
`;

export enum SpeechType {
  GOOD,
  BAD,
  GUIDE,
}

export enum SpeechGroup {
  MARKETING, // 运营话术
  TEACHER_RATE, // 老师评语
}

const SpeechGropuText = {
  [SpeechGroup.MARKETING]: '运营话术',
  [SpeechGroup.TEACHER_RATE]: '老师评语',
};

export const SpeechTypeText = {
  [SpeechType.GOOD]: '高',
  [SpeechType.BAD]: '低',
  [SpeechType.GUIDE]: '引导',
};

interface State {}

interface Props {
  lessonId: string;
  courseId: string;
}
type AllProps = RouteComponentProps<Props>;

export class SpeechDetail extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {};
  }

  render() {
    const courseId = Number(this.props.match.params.courseId);
    const lessonId = Number(this.props.match.params.lessonId);
    return (
      <>
        <Query
          query={COURSE_LIST_QUERY}
          variables={{ ids: [courseId], lessonIds: [lessonId] }}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const courses = (data && data.courses) || [];
            const [course] = courses;
            const lessons = course.lessons;
            const [lesson] = lessons;
            const speeches = lesson.speeches;
            return (
              <>
                <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
                  <Breadcrumb.Item>
                    <Link to={`/Home`}>首页</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={`/course/list`}>课程列表</Link>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item>
                    <Link to={`/course/${courseId}/lesson`}>{course.name}</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{lesson.name}</Breadcrumb.Item>
                </Breadcrumb>
                <Panel>
                  <Card title="话术详情">
                    <p>课程：{course.name}</p>
                    <p>Lesson: {lesson.name}</p>
                    <Table<Speech> dataSource={speeches} rowKey={speech => `${speech.id}`}>
                      <Table.Column width={100} title="ID" dataIndex="id" key="id" />
                      <Table.Column title="内容" dataIndex="content" key="content" />
                      <Table.Column
                        width={100}
                        title="话术类型"
                        dataIndex="type"
                        key="type"
                        render={type => SpeechTypeText[type]}
                      />
                      <Table.Column
                        width={100}
                        title="话术分类"
                        dataIndex="group"
                        key="group"
                        render={group => SpeechGropuText[group]}
                      />
                    </Table>
                  </Card>
                </Panel>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/course/SpeechDetail.tsx